import React, { useState, useEffect, useMemo } from "react";
import ReactApexChart from "react-apexcharts";
import { FaTrash } from "react-icons/fa";
import { getYearsOptions } from "../../../utilities";
import GlobalSearchableDropdown from "../../Constant/SearchableDropdown";
import { getDisposedApi } from "../../../services/DashboardServices";
import { toast } from "react-toastify";
const DisposedChart = () => {
  const [yearOption, setYearOption] = useState(getYearsOptions);
  const [selectdeYear, setSelectedYear] = useState(yearOption[0]);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const getData = () => {
    setLoading(true);
    getDisposedApi({ year: selectdeYear?.value || "" })
      .then((res) => {
        setData(res?.data?.data || []);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally((err) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getData();
  }, [selectdeYear]);

  const months = useMemo(() => data.map((item) => item.month), [data]);
  const counts = useMemo(() => data.map((item) => item.monthly_count), [data]);

  const radarChart = {
    series: [
      {
        name: "Assets Disposed",
        data: counts,
      },
    ],
    options: {
      chart: {
        height: 230,
        type: "radar",
        toolbar: { show: false },
      },
      yaxis: {
        min: 0,
        max: Math.max(...counts, 10), // ✅ auto-adjust based on max value
        tickAmount: 5,
        labels: { formatter: (val) => `${val}` },
      },
      stroke: {
        width: 2,
        colors: ["#0d6efd"],
      },
      fill: {
        opacity: 0.3,
        colors: ["#0d6efd"],
      },
      markers: {
        size: 4,
        colors: ["#fff"],
        strokeColors: "#0d6efd",
        strokeWidth: 2,
      },
      xaxis: {
        categories: months, // ✅ now dynamic
      },
      tooltip: {
        y: { formatter: (val) => `${val} items` },
      },
    },
  };

  return (
    <div className="card shadow-sm border-0">
      <div className="card-body">
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex gap-1">
            <FaTrash />
            <h5 className="ms-1">Disposed Asset</h5>
          </div>
          <GlobalSearchableDropdown
            isClearable={false}
            options={yearOption}
            selected={selectdeYear}
            onSelect={(item) => setSelectedYear(item)}
            placeholder="Year"
          />
        </div>
        <div>
          <ReactApexChart
            options={radarChart.options}
            series={radarChart.series}
            type="radar"
            height={260}
          />
        </div>
      </div>
    </div>
  );
};

export default DisposedChart;
